import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { appReducers } from './app.reducer';
import { environment } from '../environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';
import { MatIconModule } from '@angular/material/icon';
import { LandingModule } from './landing/landing.module';
import { HomePageComponent } from './landing/pages/home-page/home-page.component';
import { ChangePasswordComponent } from './clients/pages/change-password/change-password.component';
import { ForgotPasswordPageComponent } from './clients/pages/forgot-password-page/forgot-password-page.component';
import { ResetPasswordPageComponent } from './auth/pages/reset-password-page/reset-password-page.component';
import { ThanksPageComponent } from './landing/pages/thanks-page/thanks-page.component';
import { ContactPageComponent } from './landing/pages/contact-page/contact-page.component';
import { FaqPageComponent } from './landing/pages/faq-page/faq-page.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CompanyInterceptorService } from './shared/interceptors/company.interceptor';
import { ViewProductPageComponent } from './landing/pages/view-product-page/view-product-page.component';
import { PurchasePageComponent } from './landing/pages/purchase-page/purchase-page.component';
import { CoreModule } from './core/core.module';
import { MatRadioModule } from '@angular/material/radio';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { ThemeModule } from './theme/theme.module';
import { SidebarLayoutComponent } from './theme/layouts/sidebar-layout/sidebar-layout.component';
import { MatDialogModule } from '@angular/material/dialog';
import { WhyusComponent } from './landing/components/whyus/whyus.component';
import { CarouselModule } from './landing/components/carousel/carousel.module';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { LOCALE_ID } from '@angular/core';
import { SaleProductPageComponent } from './landing/pages/sale-product-page/sale-product-page.component';
import { SubscriptionProductPageComponent } from './landing/pages/subscription-product-page/subscription-product-page.component';
import { PurchaseThanksPageComponent } from './landing/pages/purchase-thanks-page/purchase-thanks-page.component';
import { ScheduleModule } from './schedule/schedule.module';

registerLocaleData(localeEsAr, 'es-AR');
@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    ThanksPageComponent,
    ContactPageComponent,
    FaqPageComponent,
    ViewProductPageComponent,
    PurchasePageComponent,
    SidebarLayoutComponent,
    WhyusComponent,
    ChangePasswordComponent,
    ForgotPasswordPageComponent,
    ResetPasswordPageComponent,
    SaleProductPageComponent,
    SubscriptionProductPageComponent,
    PurchaseThanksPageComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    StoreModule.forRoot(appReducers, {}),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    EffectsModule.forRoot([]),
    CoreModule,
    MatIconModule,
    LandingModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatRadioModule,
    ThemeModule,
    MatDialogModule,
    CarouselModule,
    GooglePlaceModule,
    ScheduleModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-Ar' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CompanyInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
